declare global {
	interface Window {
		ReactNativeWebView?: {
			postMessage: (message: string) => void;
		};
	}
}

/**
 * Safely sends a message to React Native WebView
 * @param message - The message object to send
 * @returns boolean - true if message was sent successfully, false otherwise
 */
export const sendMessageToWebView = (message: unknown): boolean => {
	try {
		if (window?.ReactNativeWebView?.postMessage) {
			window.ReactNativeWebView.postMessage(JSON.stringify(message));
			return true;
		}
		return false;
	} catch (error) {
		console.error('Error sending message to WebView:', error);
		return false;
	}
};

/**
 * Checks if the app is running in a React Native WebView
 * @returns boolean
 */
export const isWebView = (): boolean => {
	return !!window?.ReactNativeWebView;
};

/**
 * Sends contract data to React Native WebView
 * @param contract - Contract data to send
 * @param showApproveButton - Whether to show approve button
 * @returns boolean - true if sent successfully
 */
export const sendContractToWebView = (
	contract: {
		id: number;
		name: string;
		description: string;
		contractName: string;
		contractLink: string;
	},
	showApproveButton: boolean = false
): boolean => {
	return sendMessageToWebView({
		type: 'openContract',
		contract: {
			...contract,
			showApproveButton
		}
	});
};
